@if (viewType === layoutType.LIST) {
  <div class="section widget-padding element-zoom h-100">
    <div class="container-fluid h-100">
      <div class="mx-0 h-100">
        <div style="height: 90%" [ngStyle]="baseStyle">
          <div
            class="search-input w-100 mb-2 d-flex"
            *ngIf="enableSearch"
            [ngStyle]="{
              'justify-content':
                attri.widgetProperties?.inputFieldSettings?.css_config?.inputPosition ?? 'start',
            }"
          >
            <div
              [ngStyle]="{
                width:
                  attri?.widgetProperties?.inputFieldSettings?.css_config?.inputWidth !== null
                    ? attri?.widgetProperties?.inputFieldSettings?.css_config?.inputWidth + '%'
                    : '100%',
              }"
            >
              <finxone-input type="text" [placeholder]="searchPlaceHolder" (input)="searchValue($event)">
                <span prefix #prefix class="prefix-icon" *ngIf="searchIcon">
                  <mat-icon [svgIcon]="searchIcon" [ngStyle]="searchIconStyle"></mat-icon>
                </span>
              </finxone-input>
            </div>
          </div>

          @if (
            !isApiInProgress &&
            beneficiaryData.length > 0 &&
            !appBuilderShowFetchingContent &&
            !appBuilderShowNoRecordsContent
          ) {
            @if (orientation === 'vertical') {
              <finxone-web-frontend-beneficiary-selection
                class="w-100"
                [beneficiaryData]="beneficiaryData"
                [accountsData]="accountsData"
                [currencies]="currencies"
                [widgetConfig]="attri"
                [itemTemplate]="this.beneficiarySelectionTemplate"
                [contentStyle]="contentStyle"
                (scrolled)="handleChildScroll()"
                (beneficiarySelected)="selectBeneficiary($event)"
              ></finxone-web-frontend-beneficiary-selection>
            }
            @if (orientation === 'horizontal') {
              <finxone-web-frontend-common-carousel
                [beneficiaryData]="beneficiaryData"
                [currencies]="currencies"
                [carouselItemWidth]="carouselItemWidth"
                [widgetName]="widgetName"
                [templateFunction]="templateFunction"
                (itemClicked)="selectBeneficiary($event)"
                (activeIndexUpdate)="handleActiveIndexUpdate($event)"
              ></finxone-web-frontend-common-carousel>
            }
          }
        </div>

        @if (isApiInProgress || appBuilderShowFetchingContent) {
          <div class="row mx-0">
            <div class="col-12" [innerHTML]="renderApiFetchingTemplate() | safeHtml"></div>
          </div>
        } @else {
          <div
            class="row mx-0"
            *ngIf="(!beneficiaryData.length && pageNumber === 1) || appBuilderShowNoRecordsContent"
          >
            <div class="col-12" [innerHTML]="renderNoRecordsTemplate() | safeHtml"></div>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (viewType === layoutType.DROPDOWN) {
  <div>
    <ng-template #option let-item>
      <div class="d-block item" [innerHTML]="dropdownOptionItemTemplate(item) | safeHtml"></div>
    </ng-template>

    <ng-template #selected>
      <div
        *ngIf="dropdownItemSelectedTemplate() as renderedSelectedItem"
        class="d-block option-selected"
        [innerHTML]="renderedSelectedItem | safeHtml"
      ></div>
    </ng-template>

    <ng-template #dynamicFooter>
      <finxone-web-frontend-dynamic-widgets [widgetsInstance]="footerWidgetInstances">
      </finxone-web-frontend-dynamic-widgets>
    </ng-template>

    <finxone-select-dropdown
      [optionLabelKey]="'label'"
      [optionValueKey]="'value'"
      [appendToBody]="true"
      [label]="dataIn?.attri?.widgetProperties?.['inputLabel'] ?? 'Beneficiary'"
      [options]="beneficiaryListOptions"
      [selectedOption]="selectedOption?.label ?? ''"
      [searchEnabled]="true"
      (selectionChange)="onBeneficiaryChange($event, true)"
      [customOptionTemplate]="dataIn?.attri?.widgetProperties?.['dropdownItemTemplate'] ? option : null"
      [customSelectedOptionTemplate]="
        dataIn?.attri?.widgetProperties?.['selectedDropdownItemTemplate'] ? selected : null
      "
      [dropdownInputCustomStyle]="dropdownInputCustomStyle"
      [footerTemplate]="footerWidgetInstances ? dynamicFooter : null"
      [footerFloatingThreshold]="dataIn?.attri?.widgetProperties?.['floatValue']"
    >
    </finxone-select-dropdown>
  </div>
}
@if (viewType === layoutType.TABLE) {
  <finxone-web-frontend-beneficiary-selection
    class="w-100"
    [beneficiaryData]="listingBeneficiaryData"
    [appBuilderShowFetchingContent]="appBuilderShowFetchingContent"
    [accountsData]="accountsData"
    [currencies]="currencies"
    [widgetConfig]="attri"
    [itemTemplate]="this.beneficiarySelectionTemplate"
    [contentStyle]="contentStyle"
    [viewType]="viewType"
    [selectedCurrency]="beneficiariesCurrency"
    [contextSwitch]="contextSwitch"
    (scrolled)="handleChildScroll()"
    (beneficiarySelected)="selectBeneficiary($event)"
  ></finxone-web-frontend-beneficiary-selection>
}
